(function () {
  'use strict';

  var selector = '[data-annabelt-set-success]';
  var requestId = 0;

  function normalized(value) {
    return String(value || '').toLowerCase().trim();
  }

  function isBelt(item) {
    var type = normalized(item.product_type);
    var title = normalized(item.product_title || item.title);
    var handle = normalized(item.handle);

    return type === 'belt' || type.indexOf('belt') !== -1 ||
      handle.indexOf('belt-') === 0 || title.indexOf('belt') === 0;
  }

  function isBuckle(item) {
    var type = normalized(item.product_type);
    var title = normalized(item.product_title || item.title);
    var handle = normalized(item.handle);

    return type === 'buckle' || type.indexOf('buckle') !== -1 ||
      handle.indexOf('buckle-') === 0 || title.indexOf('buckle') === 0;
  }

  function isFreeBelt(item) {
    if (!isBelt(item)) return false;

    var title = normalized(item.title);
    var completelyFree = Number(item.final_line_price) === 0 && Number(item.original_line_price) > 0;
    var freeUnit = Number(item.final_price) === 0 && Number(item.original_price) > 0;
    var markedAsFree = title.indexOf('100% off') !== -1 || title.indexOf('100 % off') !== -1;

    return completelyFree || freeUnit || markedAsFree;
  }

  function qualifies(cart) {
    var paidBeltQty = 0;
    var freeBeltQty = 0;
    var buckleQty = 0;

    (cart.items || []).forEach(function (item) {
      var qty = Number(item.quantity) || 0;

      if (isBuckle(item)) buckleQty += qty;
      if (isFreeBelt(item)) {
        freeBeltQty += qty;
      } else if (isBelt(item)) {
        paidBeltQty += qty;
      }
    });

    return paidBeltQty >= 1 && buckleQty >= 1 && freeBeltQty >= 1;
  }

  function render(cart) {
    document.querySelectorAll(selector).forEach(function (banner) {
      banner.hidden = !qualifies(cart);
    });
  }

  function refresh() {
    var currentRequest = ++requestId;

    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cart) {
        if (currentRequest === requestId) render(cart);
      })
      .catch(function () {
        document.querySelectorAll(selector).forEach(function (banner) {
          banner.hidden = true;
        });
      });
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:build', function () {
    window.setTimeout(refresh, 250);
  });
  document.addEventListener('ajaxProduct:added', function () {
    window.setTimeout(refresh, 350);
  });
})();
